import { PureComponent } from 'react'
import ReactGA from 'react-ga'
import { withRouter } from 'react-router'

ReactGA.initialize('UA-185239546-1')

class GaTracking extends PureComponent {

  componentDidMount () {
    ReactGA.pageview(this.props.location.pathname + this.props.location.search)
  }

  componentWillUpdate ({ location, history }) {
    if (location.pathname === this.props.location.pathname) {
      // don't log identical link clicks (nav links likely)
      return
    }
    if (history.action === 'PUSH' || history.action === 'REPLACE') {
      ReactGA.pageview(location.pathname + location.search)
    }
  }

  render () {
    return null
  }
}

export default withRouter(GaTracking)



// WEBPACK FOOTER //
// ./src/Components/GaTracking.js